import { observer } from "mobx-react";
import * as React from "react";

import { ListPreOpsAnswers } from "../ui/molecules/list-pre-ops-answers";
import { SelectionMode, Stack } from "@fluentui/react";
import { action, makeObservable, observable } from "mobx";
import { Section } from "../ui/atoms/section";
import { DatePicker } from "../ui/organisms/date-picker";
import { endOfISOWeek, startOfISOWeek } from "date-fns";
import sizes from "../ui/sizes.scss";
import { store } from "../store";
import { articles } from "../help";
import { FusionLayout } from "@/parts/fusion-layout";

@observer
export class PagePreOpsChecklists extends React.Component {
    // Use the same defaults that're displayed in the DatePicker
    @observable public accessor dateStart: Date | undefined = startOfISOWeek(new Date());
    @observable public accessor dateEnd: Date | undefined = endOfISOWeek(new Date());

    constructor(props: {}) {
        super(props);
        makeObservable(this);
    }

    @action.bound public onDateRangeChanged(dateStart?: Date, dateEnd?: Date): void {
        this.dateStart = dateStart;
        this.dateEnd = dateEnd;
    }

    public render(): JSX.Element {
        return (
            <FusionLayout
                suggestedHelpArticles={[articles.preOpsChecklistsReport]}
                breadcrumb={store.i18n.t("page.preOpsChecklists.title")}
                classic
            >
                <Section fill>
                    <ListPreOpsAnswers
                        commandBar={
                            <Stack
                                horizontal
                                style={{ width: "100%" }}
                                horizontalAlign="end"
                                verticalAlign="center"
                                tokens={{ childrenGap: 20 }}
                            >
                                <DatePicker onDateRangeChanged={this.onDateRangeChanged} />
                            </Stack>
                        }
                        selectionMode={SelectionMode.none}
                        dateStart={this.dateStart}
                        dateEnd={this.dateEnd}
                        maxHeight={`${sizes.listMaxHeight}`}
                    />
                </Section>
            </FusionLayout>
        );
    }
}
